import img3 from './Rehabilitacion/img3.jpg'
import img4 from './Rehabilitacion/img4.jpg'
import img5 from './Rehabilitacion/img5.jpg'
import img6 from './Rehabilitacion/img6.jpg'
import img7 from './Rehabilitacion/img7.jpg'
import img8 from './Rehabilitacion/img8.jpg'
import img9 from './Rehabilitacion/img9.jpg'
import img11 from './Rehabilitacion/img11.jpg'
import img28 from './Rehabilitacion/img28.jpg'
import { Navigation } from './Navigation'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Pagination, Row, Col, Container } from 'react-bootstrap'

export class Rehabilitacion3 extends Component {
    render() {
        const productos = [
            img3, img4, img5, img6, img7, img8, img9, img11, img28
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Rehabilitación</h1>
                        </Col>
                    </Row>
                    <br />

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/rehabilitacion">{1}</Pagination.Item>
                        <Pagination.Item href="/rehabilitacion2">{2}</Pagination.Item>
                        <Pagination.Item active>{3}</Pagination.Item>
                    </Pagination>
                    <br />

                    {/* Formato de 2 columnas para máxima visibilidad de información */}
                    <Row xs={1} md={2} lg={2} className="g-5 text-center">
                        {productos.map((imagen, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2">
                                        <Card.Img 
                                            variant="top" 
                                            src={imagen} 
                                            style={{ 
                                                height: '550px', 
                                                objectFit: 'contain',
                                                width: '100%'
                                            }} 
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <br />
                    <Pagination className="justify-content-center mt-5" size="lg">
                        <Pagination.Item href="/rehabilitacion">{1}</Pagination.Item>
                        <Pagination.Item href="/rehabilitacion2">{2}</Pagination.Item>
                        <Pagination.Item active>{3}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}